import {FieldType} from "./field-type"
import FieldsFactory2 from "./fields-factory"
import CUSTOM_FIELDS_V1 from "../gd/const/fields/custom-fields-v1"
import FieldProto from "./proto/field-proto";

const fieldTypesMap = {
    [CUSTOM_FIELDS_V1.type.NUMBER]     : FieldType.NUMBER,
    [CUSTOM_FIELDS_V1.type.STRING]     : FieldType.STRING,
    [CUSTOM_FIELDS_V1.type.DATE]       : FieldType.DATE,
    [CUSTOM_FIELDS_V1.type.CURRENCY]   : FieldType.CURRENCY,
    [CUSTOM_FIELDS_V1.type.PERCENTAGE] : FieldType.PERCENTAGE,
    [CUSTOM_FIELDS_V1.type.BOOLEAN]    : FieldType.CHECKBOX,
    [CUSTOM_FIELDS_V1.type.LIST]       : FieldType.DROPDOWN,
    [CUSTOM_FIELDS_V1.type.LIST_MULTI] : FieldType.MULTISELECT,
    [CUSTOM_FIELDS_V1.type.RATING]     : FieldType.RATING,
    [CUSTOM_FIELDS_V1.type.EMAIL]      : FieldType.EMAIL,
    [CUSTOM_FIELDS_V1.type.PHONE]      : FieldType.PHONE,
    [CUSTOM_FIELDS_V1.type.URL]        : FieldType.URL,
    [CUSTOM_FIELDS_V1.type.USER]       : FieldType.USER,
    [CUSTOM_FIELDS_V1.type.TEXT]       : FieldType.TEXT,
    [CUSTOM_FIELDS_V1.type.RAG]        : FieldType.RAG,
    [CUSTOM_FIELDS_V1.type.FORMULA]    : FieldType.FORMULA,
    [CUSTOM_FIELDS_V1.type.USERS]      : FieldType.USERS,
    [CUSTOM_FIELDS_V1.type.COLOR]      : FieldType.COLOR,


    [CUSTOM_FIELDS_V1.type.REACTION]   : FieldType.REACTION,
    [CUSTOM_FIELDS_V1.type.VOTING]     : FieldType.VOTING,
    [CUSTOM_FIELDS_V1.type.ATTACHMENT] : FieldType.ATTACHMENT,
    [CUSTOM_FIELDS_V1.type.TIME_OF_DAY]: FieldType.TIME_OF_DAY,
    [CUSTOM_FIELDS_V1.type.DATE_AND_TIME]: FieldType.DATE_AND_TIME,
    [CUSTOM_FIELDS_V1.type.TOGGLE]     : FieldType.TOGGLE,
    [CUSTOM_FIELDS_V1.type.ADDRESS]    : FieldType.ADDRESS,
}

export default class Field1ToField2Converter {

    static convert(customField1Id:string):FieldProto|null {
        const field2Config = Field1ToField2Converter.getField2Config(customField1Id)
        if (field2Config) return FieldsFactory2.get(field2Config)

        console.error("#ERROR-CONVERT-1 Error converting field ", customField1Id)
        return null
    }

    static getField2Config = (customFieldId:string) => {

        const customField = gd.session.customFields.get(customFieldId);
        if (!customField) return null

        const field2Type = fieldTypesMap[customField.type]
        if (!field2Type) return null

        const convertItemsToOptions = (items:any) => _.map(items, item=>({
            value: item.id,
            label: item.value,
            color: item.color
        }))

        return {
            fieldId         : customFieldId,
            type            : field2Type,

            label           : customField.name,
            fieldAccess     : customField.access,
            isCustom        : true,

            decimalPlaces   : customField.params.decimalPlaces,                     //  FieldType.NUMBER, FieldType.CURRENCY, FieldType.PERCENTAGE, FieldType.FORMULA
            positiveOnly    : customField.params.positiveOnly,                      //  FieldType.NUMBER, FieldType.CURRENCY, FieldType.PERCENTAGE
            integersOnly    : customField.params.integersOnly,                      //  FieldType.NUMBER, FieldType.CURRENCY, FieldType.PERCENTAGE
            symbolId        : customField.params.symbol,                            //  FieldType.CURRENCY, FieldType.FORMULA
            options         : convertItemsToOptions(customField.params.listItems),  //  FieldType.DROPDOWN, FieldType.MULTISELECT

            // if true, then 'Edit options' is shown in popover and it opens new edit field modal
            // which is different from old custom field edit modal
            // but is still used to edit from List/Table/Gantt header and has scope options.
            // New edit field modal has 'Is required' option which is meaningless in List/Table/Gantt
            // showMenuMore    : false,                                                //  FieldType.DROPDOWN, FieldType.MULTISELECT
            showMenuMore    : true,                                                //  FieldType.DROPDOWN, FieldType.MULTISELECT

            scale           : customField.params.ratingType,                        //  FieldType.RATING

            formula         : customField.params.formula,                           //  FieldType.FORMULA
            formatType      : customField.params.formatType,                        //  FieldType.FORMULA
        };
    }
}
